import React, { useEffect, useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import { Box, Divider, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { getNotes, insertNotes } from "../service/api";

export default function NotesSection(props) {
  const [listOfNotes, setListOfNotes] = useState(null);
  const [noteval, setNoteVal] = useState("");
  const saveBtnEnabled = noteval ? 'closeButton saveBtnEnable' : 'closeButton';

  useEffect(() => {
    getNotesByVin();
  }, [props.vin]);

  async function getNotesByVin() {
    let apiResponse = await getNotes(props.vin);
    console.log("getNotes==>", apiResponse);
    if (apiResponse && apiResponse.status !== 404) {
      apiResponse.status === 204 ? setListOfNotes([]) : setListOfNotes(apiResponse?.data.reverse());
      
    }
  }

  const handleClick = () => {
    if (noteval) {
      insertNotes({ vin: props.vin, notes: encodeURIComponent(noteval) }).then((res) => {
        if (res) {
          getNotesByVin();
          setNoteVal("");
        }
      });
    }
  };

  return (
    <>
    {(listOfNotes) ? (<div className="notesSection">
      <ListItem className="notesSectionHeader">Notes</ListItem>
      <Box p={2}>
        <ListItem>
          <div className="noteSubSection">
            <TextField 
            className="notesText notesTextContent"
            value={noteval}
            rows={6}
            multiline
            label="Notes..."
            variant="outlined"
            onChange={(e) => {
              setNoteVal(e.target.value);
            }}
            inputProps={{ maxLength: 500 }}
          />
        {noteval?.length === 500 && <span style={{ color: 'red', fontSize: '12px', paddingLeft: '1rem' }} >Maximum Character Limit Reached</span>}
          <div className="notesCharCount">{noteval?.length}/500</div>
          </div>
        </ListItem>
        <ListItem>
          <Box ml="auto">
            <Button
              onClick={handleClick}
              className={saveBtnEnabled}
              disabled={noteval ? false : true}
              variant="contained"
            >
              Save
            </Button>
          </Box>
        </ListItem>
        <Divider />
          {listOfNotes &&
            listOfNotes.map((item, index) => {
              const itemDate = new Date(item.updated_date);
              return (
                <ListItem key={index}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <p className="notesSectionContent">{unescape(item?.notes)}</p>
                    <div style={{ fontSize: '12px', marginTop: '4px'}}>{itemDate.toLocaleString('en-US', { timeZone: 'CST' })} CT :{item.updated_by}</div>
                  </div>
                </ListItem>
              )
            })}
      </Box>
    </div>) : ('')}
    </>
  );
}
